import clsx from 'clsx'
import { Location } from 'react-router-dom'

import DetailsHeader from './DetailsHeader'
import { useAppDispatch, useAppSelector } from '../../../../../hooks'
import styles from '../../../../common/Templates/DefaultLayout/DefaultLayout.module.scss'
import Navigation from '../../../../common/Templates/DefaultLayout/Navigation/Navigation'
import { selectIsNavigationOpen, setNavigationOpen } from '../../../Other/api'

interface DetailsLayoutProps {
  children: React.ReactNode
  header: React.ReactNode
  backLink: Location | string
}

const DetailsLayout = ({
  children,
  header,
  backLink,
}: DetailsLayoutProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const navigationOpen = useAppSelector(selectIsNavigationOpen)
  const toggleNavigation = () => {
    dispatch(setNavigationOpen(!navigationOpen))
  }
  return (
    <div className={styles.root}>
      <Navigation
        isCollapsed={!navigationOpen}
        onCollapseClick={toggleNavigation}
        className={styles.navigation}
      />
      <div className={styles.mainContainer}>
        <DetailsHeader backLink={backLink}>{header}</DetailsHeader>
        <main className={clsx(styles.main, styles.mainPracticeDetails)}>
          {children}
        </main>
      </div>
    </div>
  )
}

export default DetailsLayout
